export default __webpack_public_path__ + "assets/images/72c3ba709aa4bcabe7683c8a129a34eb.svg";